import { ListPublicationV4DTO } from 'publication-types'
import { PublicationCardItemVideo } from 'common/client-data-types/card-types'

export function getExtraProps(
    document: ListPublicationV4DTO
): {
    video: PublicationCardItemVideo | undefined
    teaser: string | null
    isLive: boolean
    isPremium: boolean
    blogIsPresent: boolean
} {
    if (document.kind === 'article' || document.kind === 'redirect') {
        const video: PublicationCardItemVideo | undefined =
            document.mainVideo && document.mainVideo.kind !== 'missing-video'
                ? {
                      id: document.mainVideo.videoId,
                      accountId: document.mainVideo.accountId,
                      heading: document.mainVideo.heading,
                      source: document.source,
                      duration: null,
                      videoType: document.mainVideo.videoType,
                  }
                : undefined
        const isLive = document.isLiveContent
        const blogIsPresent = !!document.blogState

        return {
            video,
            isLive,
            isPremium: document.isPremium || false,
            blogIsPresent,
            teaser: document.homepageTeaser,
        }
    }

    if (document.kind === 'gallery') {
        return {
            video: undefined,
            teaser: document.homepageTeaser,
            isLive: false,
            isPremium: document.isPremium || false,
            blogIsPresent: false,
        }
    }

    throw new Error('Unknown document kind')
}
